<section class="revise-section  AUTO_REVISE" (clickOutside)="optionsVisibility = false" *ngIf="visible && checkpoints && checkpoints.length > 0">
  <span class="icon__icon-revise-for-toolbar icon AUTO_REVISE_BUTTON" (click)="optionsVisibility = !optionsVisibility"
        genTooltip [tooltipHtml]="tooltipHtml | stringTranslate" [tooltipPosition]="tooltipPosition"
        [appendToBody]="true" [tooltipShow]="true">
    <span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
  <section class="revise-options card-layout Auto_Revise_Button" *ngIf="optionsVisibility">
    <gen-revise-option class="revise-option"
                       (mouseover)="setWorkflowBar(option?.ui?.workflowVisibility?.barItems)"
                       (mouseleave)="setWorkflowBar()"
                       (click)="revise(option)"
                       *ngFor="let option of checkpoints; trackBy:option?.revertToStepPurpose"
                       [reviseOption]="option"></gen-revise-option>
  </section>
</section>
